<template>
    <div class="w-100 mb-5">
        <input v-for="input in file_inputs"
               :id="input.id"
               v-on:change="uploadNewFile"
               v-on:click="blockInteraction"
               type="file"
               :name="input.name"
               class="d-none"/>

        <div class="d-flex justify-content-between mb-4">
            <h4 class="mb-2">{{title}}</h4>
            <a v-if="!view_only" href="javascript:void(0)" v-on:click="openDialog()">
                <img :src="'/svg/' + resource_group + '/add.svg'" alt="">
            </a>
        </div>
        <div v-if="uploading" class="row">
            <div class="col-12">
				<loader></loader>
            </div>
        </div>
        <div class="row">
            <div class="col-12" v-for="(file, index) in files_edit">
                <hr v-if="index" class="mt-2 mb-3">
                <a :href="file.url" target="_blank" class="link-no-highlight text-secondary">
                    <img :src="'/svg/' + resource_group + '/file.svg'" alt="PlaceHolder">
                    <span>{{file.name}}</span>
                </a>
                <a v-if="!view_only" href="javascript:void(0)" class="float-right" v-on:click="deleteFile(index)">
                    <img :src="'/svg/' + resource_group + '/bin.svg'" alt="PlaceHolder">
                </a>
            </div>
        </div>

        <upload-file-modal
            title="Document"
            :upload_url="upload_url"
            ref="modal"
            @uploaded="files_edit.push($event)"
        ></upload-file-modal>
    </div>
</template>

<script>
	import UploadFileModal from "../modals/UploadFileModal";
	import Loader from "./Loader";
	export default {
		name: "FileListAndUpload",
		components: {Loader, UploadFileModal},
		props: [
        	'title',
            'files',
            'upload_url',
            'delete_url',
            'view_only'
        ],

		data(){
			return {
				indexer: 0,
				file_inputs: [],
                files_edit: [],
				uploading: false
			}
		},

        beforeMount(){
			this.files_edit = this.files || [];
        },

		methods: {
			blockInteraction (e){
				if (e.target.files.length){
					e.preventDefault();
					return;
				}
			},

			deleteFile(index){
				let _this = this, file = _this.files_edit[index];
				_this.files_edit.splice(index, 1);

				axios.delete(_this.delete_url.replace('?', file.id))
            },

			uploadNewFile(e){
				let files_in_input = e.target.files || e.dataTransfer.files;

				if (!files_in_input.length){
					if (typeof e.target.remove === 'function') {
						e.target.remove();
					} else {
						e.target.parentNode.removeChild(e.target);
					}
					return;
				}

				this.$refs.modal.open(files_in_input[0]);
			},

			openDialog(){
				let _this = this;

				_this.indexer ++;

				_this.file_inputs.push({
					id: 'file_uploader-' +_this.indexer,
					name: 'file-' + _this.indexer
				});

				window.setTimeout(function (){
					document.getElementById('file_uploader-' + _this.indexer).click();

					document.body.onfocus = function(){
						document.body.onfocus = null;

						window.setTimeout(function (){
							if (document.getElementById('file_uploader-' + _this.indexer).files.length === 0){
								_this.file_inputs.pop();
							}
						}, 500);
					};
				}, 150);
			},
		}
	}
</script>
